import * as types from "./types";

const mutations = {
    [types.LOADING_WEBSITEBUILDERS](state, value) {
        state.loading = value;
    },
    [types.GET_WEBSITE](state, website) {
        state.website = website;
    },
    
    [types.UPDATE_WEBSITEBUILDERS](state, websitebuilders) {        
        state.website =        websitebuilders;
    },
   
};

export default mutations;